module.exports = "<div class=\"alloc-popup-wrapper\">\n\n  <lfwms-result-data-table [showSelectOption]=\"false\" \n[searchService]=\"lookupSearchService\">\n</lfwms-result-data-table>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-alloc-summary-popup/wave-alloc-summary-popup.component.html
// module id = ../../../../../src/app/shared/lookup/wave-alloc-summary-popup/wave-alloc-summary-popup.component.html
// module chunks = main